module.exports = __webpack_public_path__ + "FoleyArtists.jpg?2f58377d6f7951ab899c4c913cbc0969";


//////////////////
// WEBPACK FOOTER
// ./public/creator-avatar/FoleyArtists.jpg
// module id = 476
// module chunks = 0